<template>
  <div id="faq-edit">
    <v-card
      :loading="loadingState"
      class="mb-3"
    >
      <v-card-title>
        {{cardTitle}}

        <v-spacer />

        <v-btn
          color="error"
          @click="deleteDialog = true"
          v-if="canRemove && userCanDelete"
          :disabled="loadingState"
        >Удалить</v-btn>
      </v-card-title>
    </v-card>

    <v-scroll-y-reverse-transition>
      <v-alert
        v-if="isCreateNew && !userCanCreate"
        type="error"
      >
        Нет доступа.
      </v-alert>

      <v-card
        v-else-if="entityData"
        class="mb-3"
      >
        <v-tabs
          v-model="currentTab"
          show-arrows
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab
            v-for="tab in tabs"
            :href="`#tab-${tab.index}`"
            :key="tab.index"
            :disabled="!tab.component"
          >
            {{tab.title}}
          </v-tab>
        </v-tabs>

        <v-tabs-items
          v-model="currentTab"
          class="mt-3"
        >
          <v-tab-item
            v-for="tab in tabs"
            :key="tab.index"
            :value="`tab-${tab.index}`"
          >
            <v-card flat>
              <v-card-text>
                <component
                  ref="tabContent"
                  :is="tab.component"
                  :entity-data="entityData"
                  v-bind="tab.props"
                  v-model="editInfo"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-scroll-y-reverse-transition>

    <v-scroll-y-reverse-transition>
      <entity-card-actions
        :saving="saving"
        :loading-state="loadingState"
        :can-save="isCreateNew ? userCanCreate : userCanUpdate"
        @save="saveItem"
        @saveAndClose="saveAndClose"
        @close="close"
        v-if="entityData"
      />
    </v-scroll-y-reverse-transition>

    <delete-faq-dialog
      v-model="deleteDialog"
      :entity-id="$route.params.id"
      @deleted="handleDeleted()"
      v-if="canRemove && userCanDelete"
    />
  </div>
</template>

<script>
import { EditFaq } from "@/components/faq/edit";
import { DeleteFaqDialog } from "@/components/faq/Dialogs";
import { EntityCard } from "@/mixins";

export default {
  mixins: [EntityCard],

  components: {
    EditFaq,
    DeleteFaqDialog
  },

  data: () => ({
    createNewTitle: "Новый вопрос",
    notFoundMessage: "Вопрос не найден.",

    // API
    apiEntityName: "faq",
    apiFetchMethodName: "faq",
    apiCreateMethodName: "createFaq",
    apiUpdateMethodName: "updateFaq",

    // Router
    routerIndexName: "FaqIndex",
    routerEditName: "FaqEdit",

    policyKey: 'faq_policy'
  }),

  computed: {
    tabs() {
      return [
        {
          index: 1,
          title: "Основное",
          component: "EditFaq"
        }
      ];
    },

    cardTitle() {
      if (this.isCreateNew) {
        return this.createNewTitle;
      }

      return this.dbData ? `Вопрос #${this.dbData.id}` : "Загрузка...";
    },

    canRemove() {
      return this.dbData && !this.isCreateNew;
    },

    deletedMessage() {
      return `Вопрос #${this.dbData.id} удален.`;
    }
  }
};
</script>